export enum CopyTo {
    ToAllStudent = "ToAllStudent",
    ToOtherClass = "ToOtherClass"
}
